module.exports = __webpack_public_path__ + "assets/img/operate36.cba2c8ee.jpg";